import React from 'react';
import {
  LineageBrowserDataCatalogProvider,
  VizPortalDataCatalogProviderProps,
} from '../../../data-catalog-shared';
import { VirtualConnectionTableLineageSubplaceRouter, VirtualConnectionTableLineageSubplaceRouterProps } from './VirtualConnectionTableLineageSubplace';

export type EmbeddableVirtualConnectionTableSubplaceProps = VizPortalDataCatalogProviderProps & VirtualConnectionTableLineageSubplaceRouterProps;

export function EmbeddableVirtualConnectionTableSubplaceWithoutRouter(props: EmbeddableVirtualConnectionTableSubplaceProps): JSX.Element {
  return (
    <LineageBrowserDataCatalogProvider {...props}>
      <VirtualConnectionTableLineageSubplaceRouter vizportalUrlId={props.vizportalUrlId} />
    </LineageBrowserDataCatalogProvider>
  );
}
